import { createContext, useContext } from "react";

const THEME_PREFERENCES = ["light", "dark", "system"] as const;

export type ThemePreference = (typeof THEME_PREFERENCES)[number];

export type ResolvedTheme = "light" | "dark";

export type ThemeContextThemeOption = {
  id: ThemePreference;
  label: string;
  description: string;
};

type ThemeContextValue = {
  /** The stored user choice — "system" defers to the OS setting. */
  themePreference: ThemePreference;
  /** The effective theme after resolving "system" against the OS setting. */
  resolvedTheme: ResolvedTheme;
  themeOptions: ThemeContextThemeOption[];
  selectTheme: (preference: ThemePreference) => void;
};

export const isThemePreference = (value: unknown): value is ThemePreference =>
  THEME_PREFERENCES.includes(value as ThemePreference);

export const themeContextDefaultValue: ThemeContextValue = {
  themePreference: "system",
  resolvedTheme: "light",
  themeOptions: [],
  selectTheme: () => {},
};

export const ThemeContext = createContext<ThemeContextValue>(themeContextDefaultValue);

export const useThemeContext = () => useContext(ThemeContext);
